import { render } from "./PersonasPage.vue?vue&type=template&id=07e51ff2"
import script from "./PersonasPage.vue?vue&type=script&lang=js"
export * from "./PersonasPage.vue?vue&type=script&lang=js"

import "./PersonasPage.vue?vue&type=style&index=0&id=07e51ff2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__